import EditInfoSelectedProvider from '@/components/edit-info-selected-provider/index.vue'

export default {
  components: {
    EditInfoSelectedProvider
  },
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    editing: {
      required: true,
      type: Boolean,
      default: false
    },
    actionItem: {
      required: true,
      type: Function
    },
    selectedBasketType: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  mounted () {
    this.dialog = true
  },
  methods: {
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
